import { IconButton } from '@src/shared/ui/Button';
import { ChevronLeftIcon, ChevronRightIcon } from '@src/shared/ui/icons';
import type { PickersCalendarHeaderProps } from '@src/shared/ui/inputs';
import { Box } from '@src/shared/ui/layout';
import Typography from '@src/shared/ui/Typography';
import { useTranslation } from 'react-i18next';

export default function CalendarHeader(props: PickersCalendarHeaderProps) {
  const { currentMonth, onMonthChange } = props;
  const { t } = useTranslation();

  const prevYear = new Date(currentMonth);
  prevYear.setFullYear(prevYear.getFullYear() - 1);

  const nextYear = new Date(currentMonth);
  nextYear.setFullYear(nextYear.getFullYear() + 1);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <IconButton
        size="small"
        onClick={() => onMonthChange(prevYear)}
        tooltipTitle={t('common.previous', 'Previous')}
      >
        <ChevronLeftIcon />
      </IconButton>
      <Typography variant="h4">{currentMonth.getFullYear()}</Typography>
      <IconButton
        size="small"
        onClick={() => onMonthChange(nextYear)}
        tooltipTitle={t('common.next', 'Next')}
      >
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
}
